var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./Company.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-1b711360!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Company.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Company/Company.vue
// module id = 392
// module chunks = 1